import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history2/19th_Century_-_Scramble_for_Africa.png';

function HistoryPageScrambleForAfricaGo() {
  return (
    <QuizPage
      title="History: Scramble for Africa"
      subTopic="Scramble for Africa"
      backgroundImage={historyImage}
      returnPath="/History-Scramble-For-Africa"
    />
  );
}

export default HistoryPageScrambleForAfricaGo;
